"use strict";
import { useEffect } from "react";
import { isEscape } from "../../util/key-codes.js";
function useEscapeKey(callback, active = true) {
  useEffect(() => {
    if (!active) {
      return void 0;
    }
    const handleEscapePress = (event) => {
      if (isEscape(event)) {
        callback(event);
      }
    };
    document.addEventListener("keydown", handleEscapePress);
    return () => {
      document.removeEventListener("keydown", handleEscapePress);
    };
  }, [callback, active]);
}
export {
  useEscapeKey
};
